export default __webpack_public_path__ + "static/media/excel.5922345a.svg";